import { render, staticRenderFns } from "./WorkbenchCatLogo.vue?vue&type=template&id=3bfa31b0&scoped=true"
import script from "./WorkbenchCatLogo.vue?vue&type=script&lang=js"
export * from "./WorkbenchCatLogo.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchCatLogo.vue?vue&type=style&index=0&id=3bfa31b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa31b0",
  null
  
)

export default component.exports